import * as React from "react";
import { cn } from "@/lib/utils";
import { useFormDensity } from "./form-density";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "default" | "soft";
  inputSize?: "sm" | "md";
  invalid?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, variant = "soft", inputSize, invalid = false, ...props },
    ref,
  ) => {
    const density = useFormDensity();
    const effSize = inputSize ?? density;
    return (
      <input
        type={type}
        aria-invalid={invalid || undefined}
        className={cn(
          "flex w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground outline-none focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          effSize === "sm" ? "h-9" : "h-10",
          variant === "soft"
            ? "border-input focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 focus:border-primary/40"
            : "border-input focus:ring-2 focus:ring-ring focus:ring-offset-2",
          invalid &&
            "border-destructive/50 focus:ring-destructive/30 focus:border-destructive/50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
